/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { useUnstyled as s } from "../unstyled/main.mjs";
const a = (e) => t.forwardRef((r, o) => {
  const n = s();
  return /* @__PURE__ */ t.createElement(e, { ...r, ref: o, unstyled: n });
});
export {
  a as withUnstyledHOC
};
